import PublicRequestPage from "./PublicRequestPage";
import { useLocal } from "hooks/useLocal";

const DeleteMePage = () => {
  const { isArabic } = useLocal();

  const copy = isArabic
    ? {
        title: "طلب حذف الحساب",
        subtitle:
          "شارك بريدك الإلكتروني ورقم هاتفك. سنحتفظ بهذا الطلب لمدة 60 يومًا. إذا قمت بتسجيل الدخول مرة أخرى خلال هذه الفترة، فسيتم اعتبار ذلك إلغاءً لطلب حذف الحساب.",
        ctaLabel: "طلب حذف الحساب",
        successTitle: "تم استلام الطلب",
        successDescription:
          "سيقوم أحد أعضاء فريق Numuw بالتواصل معك لتأكيد الخطوات التالية.",
      }
    : {
        title: "Request account deletion",
        subtitle:
          "Share your email and phone number. We will keep this request for 60 days. If you sign in again during that period, we will treat it as cancellation of the deletion request.",
        ctaLabel: "Request deletion",
        successTitle: "Request received",
        successDescription:
          "Someone from the Numuw team will reach out to confirm the next steps.",
      };

  return (
    <PublicRequestPage
      endpoint="/api/landing/delete-request/"
      title={copy.title}
      subtitle={copy.subtitle}
      ctaLabel={copy.ctaLabel}
      successTitle={copy.successTitle}
      successDescription={copy.successDescription}
    />
  );
};

export default DeleteMePage;
